import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { HeaderModule } from './ui-components/header/header.module';
import { UserModule } from './users/user.module';

import { AppComponent } from './app.component';
import { PageConfig } from '../config/page.config';
import { SpinnersModule } from './ui-components/spinners/spinners.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { InvalidPermissionsModule } from './invalid-permissions/invalid-permissions.module';
import { AnalyticsModule } from './analytics/analytics.module';
import { OneColumnLayoutComponent } from './layouts/one-column-layout/one-column-layout.component';
import { AlertsModule } from './ui-components/alerts/alerts.module';
import { FooterComponent } from './layouts/footer/footer.component';
import { DateTimeService } from 'app/utilities/date-time.service';
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { MatExpansionModule } from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import { OCMUserModule } from './ocmuser/ocmuser.module';
import { OCMAdminModule } from './ocmadmin/ocmadmin.module';
import { ApiTokenInterceptorInterceptor } from './api-token-interceptor.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    OneColumnLayoutComponent,
    FooterComponent
  ],
  imports: [
    AnalyticsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HeaderModule,
    AlertsModule,
    OCMUserModule,
    OCMAdminModule,
    PageNotFoundModule,
    InvalidPermissionsModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnersModule,
    UserModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatExpansionModule,
    MatFormFieldModule
    
  ],
  providers: [
    DateTimeService,
    PageConfig,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiTokenInterceptorInterceptor,
      multi: true
    }
  ],
  // schemas: [
  //   CUSTOM_ELEMENTS_SCHEMA
  // ],
  bootstrap: [
    AppComponent
   ]
})
export class AppModule { }
